import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiGatewayHelperService } from 'modules/app/services/apigateway-helper.service';
@Injectable()
export class GradeActivitySelectionService {
  constructor(
      private http: HttpClient,
      private apiGatewayHelperService: ApiGatewayHelperService
  ) {}

  public saveGradeActivitySelection(spaceId, classId, params) {
    return this.http.post(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + spaceId + '/class/' + classId + '/save-grade-activity-selection', params);
  }
}